module.exports = __webpack_public_path__ + "static/media/heatblockShadow.ad6c46cd.svg";